/*下面是增加的*/
import LibrarianEdit from './views/LibrarianEdit.vue';
/*上面是增加的*/
import { createRouter, createWebHistory } from 'vue-router';
import Login from './views/Login.vue';
import LibrarianList from './views/LibrarianList.vue';
/* import LibrarianEdit from './views/LibrarianEdit.vue';  (可选) */

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: Login,
    },
    {
        path: '/',
        name: 'LibrarianList',
        component: LibrarianList,
        meta: { requiresAuth: true },
    },
    {
        path: '/librarians/edit/:id',
        name: 'LibrarianEdit',
        component: LibrarianEdit,
        props: true, // 将路由参数作为 props 传递给组件
        meta: { requiresAuth: true, backRoute: 'LibrarianList' }, // 定义返回路由，方便NavBar
    },
    { path: '/:pathMatch(.*)*', redirect: '/' } // 未匹配的路由重定向到首页
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to, from, next) => {
    const loggedIn = localStorage.getItem('token');
    if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
        next('/login');
    } else {
        next();
    }
});

export default router;